import { render, staticRenderFns } from "./ShitShell.vue?vue&type=template&id=ac8205e2&"
import script from "./ShitShell.vue?vue&type=script&lang=js&"
export * from "./ShitShell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports